<template>
  <div>
    <Pane />

    <a-card class="container">
      <a-form-model layout="inline" @keyup.enter.native="query">
        <a-row>
          <a-col :span="22">
            <a-form-model-item>
              <EmployeeSelector
                @change="
                  (arr) => {
                    if (arr.length) {
                      selectedApplicant = arr[0];
                      form.applicantId = arr[0].userId;
                    } else {
                      selectedApplicant = {};
                      form.applicantId = undefined;
                    }
                  }
                "
                :value="selectedApplicant.name ? [selectedApplicant] : []"
              >
                <a-button block style="text-align: left; width: 180px">
                  <span v-if="selectedApplicant.name">{{ selectedApplicant.name }}</span>
                  <span v-else style="color: #999">申请人</span>
                </a-button>
              </EmployeeSelector>
            </a-form-model-item>

            <a-form-model-item>
              <a-select
                v-model="form.departmentId"
                placeholder="申请部门"
                allowClear
                style="width: 180px"
              >
                <a-select-option
                  v-for="item in organizationList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.uniqueName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-col>

          <a-col :span="2">
            <div class="right" style="margin-top: 4px">
              <a-button
                v-if="$getPermission($route.path + '/add')"
                @click="addVisible = true"
                type="primary"
              >添加</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding />

      <a-table
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <template slot="statusCol" slot-scope="text">
          <a-tag :color="getStatusColor(text)">{{ getStatusName(text) }}</a-tag>
        </template>
        <template slot="categoryCol" slot-scope="text">
          {{ getCategoryLabel(text) }}
        </template>
        <template slot="actionCol" slot-scope="text, record">
          <a-space>
            <a href="#" @click.prevent="showDetail(record)">详情</a>
          </a-space>
        </template>
      </a-table>
    </a-card>

    <!-- 添加物资采购记录弹窗 -->
    <a-modal
      :visible="addVisible"
      title="添加物资采购记录"
      :footer="null"
      :maskClosable="false"
      width="70%"
      @cancel="addVisible = false"
    >
      <AddRecord
        v-if="addVisible"
        :inModal="true"
        @close="addVisible = false"
        @success="getList"
      />
    </a-modal>

    <!-- 物资采购记录详情弹窗 -->
    <a-modal
      :visible="detailVisible"
      title="物资采购记录详情"
      :footer="null"
      width="70%"
      @cancel="detailVisible = false"
    >
      <a-spin :spinning="detailLoading">
        <AddRecord
          v-if="detailRecord"
          :inModal="true"
          :detailData="detailRecord"
          @close="detailVisible = false"
        />
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import organization from "@/mixins/organization";
import EmployeeSelector from "@/components/employee-selector";
import { fetchOfficeList, fetchOfficeDetail } from "@/api/oa/purchaseMaterials";
import AddRecord from "./add.vue";
import { mapGetters } from "vuex";

export default {
  mixins: [watermark, organization],

  components: {
    AddRecord,
    EmployeeSelector,
  },

  data() {
    return {
      form: {},
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      selectedApplicant: {},

      addVisible: false,
      detailVisible: false,
      detailRecord: null,
      detailLoading: false,

      columns: [
        { title: "审批状态", dataIndex: "status", align: "center", scopedSlots: { customRender: "statusCol" } },
        { title: "申请人", dataIndex: "applicantName" },
        { title: "申请部门", dataIndex: "departmentName" },
        { title: "类别", dataIndex: "purchaseCategory", align: "center", scopedSlots: { customRender: "categoryCol" } },
        { title: "申请日期", dataIndex: "applyDate", align: "center" },
        { title: "创建时间", dataIndex: "createAt", align: "center" },
        {
          title: "操作",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "actionCol" },
        },
      ],
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    statusList() {
      return this.findDataDict("taskReviewStatus");
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    getCategoryLabel(value) {
      const map = { wine: '酒水', gift: '礼品', material: '物料' };
      return map[value] || value;
    },

    getStatusName(statusValue) {
      if (!this.statusList || !Array.isArray(this.statusList)) return statusValue;
      const status = this.statusList.find(item => item.value === statusValue);
      return status ? status.name : statusValue;
    },

    getStatusColor(statusValue) {
      if (!this.statusList || !Array.isArray(this.statusList)) return 'geekblue';
      const status = this.statusList.find(item => item.value === statusValue);
      return status ? status.icon : 'geekblue';
    },

    getList() {
      const { current, pageSize, form } = this;
      this.loading = true;
      fetchOfficeList({
        pageNum: current,
        pageSize,
        ...form,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.total = res.totalSize;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },

    reset() {
      this.form = {};
      this.selectedApplicant = {};
      this.current = 1;
      this.getList();
    },

    showDetail(record) {
      this.detailLoading = true;
      this.detailVisible = true;
      this.detailRecord = null;
      fetchOfficeDetail(record.id)
        .then((res) => {
          this.detailRecord = { ...record, ...res };
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },
  },
};
</script>